/**
 * 네이티브(Capacitor) 전용 리스너
 * 1) 안드로이드 뒤로가기: SPA 히스토리 back, 첫 화면이면 앱 백그라운드
 * 2) 소셜 로그인 딥링크 복귀: freematch://auth?token=... → 토큰 저장 후 로그인 완료
 */
import { Capacitor } from '@capacitor/core';
import { App as CapApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { setToken } from './auth';

let initialized = false;

export function initNativeAppListeners(): void {
  if (!Capacitor.isNativePlatform() || initialized) return;
  initialized = true;
  console.log('[AppNative] 네이티브 리스너 등록');

  // 안드로이드 시스템 뒤로가기 버튼
  CapApp.addListener('backButton', ({ canGoBack }) => {
    console.log('[AppNative] backButton, canGoBack:', canGoBack);
    if (canGoBack) {
      window.history.back();
    } else {
      // 더 갈 곳이 없으면 앱을 종료하지 않고 백그라운드로
      CapApp.minimizeApp();
    }
  });

  // 딥링크: freematch://auth?token=...&provider=...
  CapApp.addListener('appUrlOpen', async ({ url }) => {
    console.log('[AppNative] appUrlOpen:', url);
    if (!url || !url.startsWith('freematch://auth')) return;
    try {
      const qs = url.split('?')[1] || '';
      const params = new URLSearchParams(qs);
      const token = params.get('token');
      if (token) {
        setToken(token);
        console.log('[AppNative] 소셜 로그인 토큰 저장 완료 → /services 이동');
        try { await Browser.close(); } catch { /* Custom Tab이 이미 닫혔으면 무시 */ }
        // AuthContext가 새 토큰으로 초기화되도록 전체 리로드
        window.location.href = '/services';
      } else {
        console.error('[AppNative] 딥링크에 토큰 없음');
      }
    } catch (e) {
      console.error('[AppNative] 딥링크 처리 실패:', e);
    }
  });
}
